import React from 'react';
import { Image, T, Tooltip } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import clsx from 'clsx';
import { getMembershipImage, getMembershipTitle } from '../utils.ts';
import styles from './RankCell.module.scss';
export const RankCell = ({ rank, membershipType, onClickMembershipIcon })=>{
    const handleMembershipClick = (event)=>{
        event.stopPropagation();
        if (membershipType == undefined) return;
        onClickMembershipIcon === null || onClickMembershipIcon === void 0 ? void 0 : onClickMembershipIcon(membershipType);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.rankCell
    }, /*#__PURE__*/ React.createElement("div", null, typeof rank === 'number' ? `#${rank}` : rank), membershipType !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        delay: 0,
        position: "top",
        centerText: true,
        disableOnTouch: true,
        content: /*#__PURE__*/ React.createElement(T, {
            id: getMembershipTitle(membershipType)
        })
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: getMembershipImage(membershipType),
            alt: emptyTranslation
        },
        className: clsx(styles.membershipImage, {
            [styles.clickable]: onClickMembershipIcon != undefined
        }),
        onClick: handleMembershipClick
    })));
};
